import { Flex, Typography } from 'antd';
import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { CLEANING_AREA_LIST_MIN_HEIGHT } from '../CleaningZones.styles';

export const CleaningAreaOrderListContainer = styled(Flex)`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    flex: 1;
    min-width: 0;
    align-self: flex-start;
    min-height: ${CLEANING_AREA_LIST_MIN_HEIGHT}px;
    height: auto;
    overflow-y: auto;
    overflow-x: hidden;
    gap: ${kcc.spacing.XS};
  `}
`;

export const CleaningAreaDropIndicator = styled.div`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    position: relative;
    flex-shrink: 0;
    height: 2px;
    background-color: ${kcc.colors.BLUE[800]};
    pointer-events: none;

    /* The end dots are 6px circles centered on this 2px line, so they overflow 2px above/below
       its own box. Sibling rows normally absorb that via the list's flex gap — but as the very
       first/last child there's no sibling gap on that side, so the dot gets clipped by the list's
       overflow-y. Only THIS element gets the extra room (not the container), so resting list
       alignment is unaffected when no indicator is rendered. */
    &:first-child {
      margin-top: 2px;
    }

    &:last-child {
      margin-bottom: 2px;
    }

    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: ${kcc.colors.BLUE[800]};
      transform: translateY(-50%);
    }

    &::before {
      left: 0;
    }

    &::after {
      right: 0;
    }
  `}
`;

export const CleaningAreaListEmptyMessage = styled(Typography.Text)`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    &.ant-typography {
      color: ${kcc.colors.TEXT_DESCRIPTION};
      font-size: ${kcc.typography.FONT_SIZE.BASE}px;
      padding: ${kcc.spacing.SM};
    }
  `}
`;
